import React from "react"
import { Tag, Pagination, Tooltip } from "antd"
import { size, map, _ } from "lodash"
import CopyToClipboard from "react-copy-to-clipboard"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { Button, Card, CardBody, Badge } from "reactstrap"
import BootstrapTable from "react-bootstrap-table-next"

export default class RoleList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      viewmodal: false,
      modal: false,
      orders: [],
      userColumns: [
        {
          dataField: "roleName",
          text: "Role Name",
          sort: true,
        },
        {
          dataField: "createdByName",
          text: "Created By",
          sort: true,
        },
        {
          dataField: "permissions",
          text: "Permissions",
          sort: true,
          formatter: (cellContent, role) => {
            // let applicationsData = role.applications.filter((item) => item.applicationCode === this.state.appCode);
            // let filteredApp = applicationsData && applicationsData.length>0 ? applicationsData[0] : {};
            // let permissionsArr = !_.isEmpty(filteredApp) ? (filteredApp["include_permissions"] && filteredApp["include_permissions"].length > 0 ?  filteredApp["include_permissions"] : []) : []
            return (
              <div>
                {map(
                  role.permissions,
                  (tag, index) =>
                    index < 1 && (
                      <Badge className="badge-soft-info ms-1">
                        <div className="font-size-12 p-1">{tag}</div>
                      </Badge>
                    )
                )}
                {size(role.permissions) > 1 && (
                  <Badge className="badge-soft-success ms-1">
                    <Tooltip
                      placement="right"
                      title={role.permissions
                        .slice(1, role.permissions.length)
                        .map(a => (
                          <div>{a}</div>
                        ))}
                    >
                      <div className="font-size-12 p-1">
                        +{size(role.permissions) - 1} more
                      </div>
                    </Tooltip>
                  </Badge>
                )}
              </div>
            )
          },
        },
        {
          dataField: "status",
          text: "Status",
          sort: true,
          formatter: (cellContent, role) => {
            return (
              <div>
                <Badge
                  className={
                    role.roleStatus === "active"
                      ? "badge-soft-success ms-1 rounded-pill px-3"
                      : "badge-soft-warning ms-1 rounded-pill px-3"
                  }
                >
                  <div className="font-size-12 p-1">
                    {role.roleStatus === "active" ? "Active" : "Disabled"}
                  </div>
                </Badge>
              </div>
            )
          },
        },
        {
          dataField: "menu",
          isDummyField: true,
          editable: false,
          text: "Actions",
          formatter: (cellContent, role) => (
            <div className="d-flex align-items-center gap-3">
              <div role="button" className="text-success">
                <i
                  className="bx bx-edit-alt me-1 font-size-18 fw-bold"
                  id="edittooltip"
                  onClick={e => {
                    e.stopPropagation(),
                      e.preventDefault(),
                      this.props.handleEditClick(role)
                  }}
                ></i>
              </div>
              <div>
                <CopyToClipboard
                  text={role.roleId}
                  onCopy={e => {
                    toastr.success("Copied sucessfully!")
                  }}
                >
                  <Tooltip title="Copy Role ID">
                    <i
                      className="bx bx-copy me-1 font-size-18 fw-bold"
                      role="button"
                    />
                  </Tooltip>
                </CopyToClipboard>
              </div>
              <div role="button" className="text-danger">
                <i
                  className="bx bx-trash-alt font-size-18 fw-bold"
                  id="deletetooltip"
                  onClick={e => {
                    // if (
                    //   !this.props.currentUser?.permissions?.includes(
                    //     "EDIT_COMMUNITY_MANAGEMENT"
                    //   )
                    // ) {
                    //   toastr.error(NO_PERMISSION_MESSAGE)
                    //   return
                    // }
                    e.stopPropagation(),
                      e.preventDefault(),
                      this.props.handleDeleteRole(role.roleId)
                  }}
                ></i>
              </div>
            </div>
            // <Button
            //   type="button"
            //   color="primary"
            //   className="btn-sm btn-rounded"
            //   onClick={this.toggleViewModal}
            // >
            //   View Details
            // </Button>
          ),
        },
      ],
    }
    // this.toggle = this.toggle.bind(this)
    // this.toLowerCase1 = this.toLowerCase1.bind(this)
  }
  render() {
    const { roleList } = this.props
    const defaultSorted = [
      {
        dataField: "name",
        order: "desc",
      },
    ]
    return (
      <div>
        {this.props.total &&
          this.props.roleList &&
          this.props.roleList.length > 0 && (
            <div style={{ textAlign: "center" }} className="mb-2">
              <Tag color="geekblue">
                Showing <b>{this.props.roleList.length}</b> of{" "}
                <b>{this.props.total}</b> Roles
              </Tag>
            </div>
          )}
        {this.props.roleList.length > 0 && (
          <div className="user-card-container">
            <Card>
              <CardBody>
                <ToolkitProvider
                  keyField="id"
                  data={roleList}
                  columns={this.state.userColumns}
                  bootstrap4
                  search
                >
                  {toolkitProps => (
                    <React.Fragment>
                      <div className="table-responsive">
                        <BootstrapTable
                          {...toolkitProps.baseProps}
                          // {...paginationTableProps}
                          responsive
                          defaultSorted={defaultSorted}
                          bordered={false}
                          striped={false}
                          // selectRow={selectRow}
                          classes={
                            "table align-middle table-nowrap table-check"
                          }
                          headerWrapperClasses={"table-light"}
                        />
                      </div>
                    </React.Fragment>
                  )}
                </ToolkitProvider>
              </CardBody>
            </Card>
            <div className="d-flex justify-content-end mb-2">
              <Pagination
                style={{
                  marginTop: "1rem",
                  listStyle: "none",
                  display: "flex",
                }}
                onChange={val => this.props.onPageChange(val)}
                defaultCurrent={this.props.currentPage}
                total={this.props.total < 10000 ? this.props.total : 10000}
                pageSize={this.props.pageSize}
                showSizeChanger={false}
              />
            </div>
          </div>
        )}
      </div>
    )
  }
}
